<template>
  <html lang="pt-br">
    <head>      
      <meta name="description" content="Artigos e Publicações">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

        <section class="section about p-0">
          <div class="container" style="margin-top:80px">
            <div class="row">
              <div class="col-lg-6 align-self-center">
                <div class="content text-center text-lg-left">
                  <h2>Simples Nacional - Treinamento do SEFISC - Versão 4.0</h2>

                  <p>
                    A Secretaria-Executiva do Comitê Gestor do Simples Nacional (CGSN/SE) promoverá o segundo evento de capacitação para servidores efetivos, 
                    usuários e multiplicadores, do Sefisc (Sistema Eletrônico Único de Fiscalização e Contencioso) versão 4.0, 
                    que ocorrerá no período de 21 a 25 de novembro de 2022.
                    <br>
                    O evento ocorrerá no formato remoto pela plataforma Teams das 14h às 17h, exceto no dia 24/11, que ocorrerá na parte da manhã (09:00 às 12:00), 
                    totalizando uma carga horária de 15h/aula.
                    <br><br>
                    Os servidores indicados pelos entes federados devem atender aos requisitos abaixo listados, cabendo à cada representação a responsabilidade pela sua observância:
                    <br>
                    1 - Ser servidor da carreira de auditoria fiscal, com competência legal para lançamento de ofício de tributos do Simples Nacional;
                    <br>
                    2 - Ter conhecimento e atuar preferencialmente na área de fiscalização do Simples Nacional; 
                    <br>
                    3 - Possuir certificado digital válido – Padrão ICP Brasil;
                    <br>
                    4 - Ter perfil de usuário do SEFISC cadastrado no Portal dos Entes Federados:
                    Estados/DF e Municípios: GESTOR ou Fiscal-ENTE (habilitado pelo Usuário-Cadastrador local)
                    RFB: Fiscal-RFB (habilitado por meio do e-Fau, em ENTES-SINAC-P)
                    <br>
                    5 - Possuir perfil de multiplicador de conhecimento.
                    Para fins de inscrição, os entes federados interessados deverão encaminhar o pedido de cada um dos indicados para os seus representantes na CGSN/SE, abaixo listados:
                    CONFAZ (Estados/DF) – Nazario Rodolfo de Melo (nazario.melo@sefaz.pb.gov.br) ABRASF (Municípios Capitais) – Irineu Vieira Bueno Junior (irineubueno@pbh.gov.br) CNM (Municípios Não Capitais) - financas@cnm.org.br
                    O email deverá conter os dados do candidato (nome, cargo, CPF, e-mail e celular de contato), e o print da tela de acesso à funcionalidade SEFISC/AINF 4.0.
                    <br><br>
                    O prazo final para os entes federados encaminharem os pedidos aos seus representantes é 14/10/2022.
                    Os representantes da RFB, CONFAZ, ABRASF e CNM encaminharão os pedidos validados para as seguintes caixas corporativas (simples08.sefisc@rfb.gov.br) e (simples.pe.esc04@rfb.gov.br) até o dia 01/11/2022.
                    <br>
                    A CGSN/SE será responsável pelo controle de preenchimento das vagas existentes a partir do recebimento das indicações validadas, observando o limite estabelecido e obedecendo a ordem cronológica de suas entradas.
                    <br>
                    Os representantes dos entes federados poderão enviar indicações em número superior ao limite estabelecido, pois caso as vagas destinadas a determinado grupo de entes federados não sejam por eles preenchidas, as vagas em aberto serão alocadas conforme lista de reserva, priorizando os entes federados que efetivamente utilizam o SEFISC, de acordo com levantamento realizado pela CGSN/SE.
                    <br>
                    A alocação das vagas procurará atender à maior quantidade possível de Estados e Municípios, por isso somente haverá inscrição de mais de dois participantes do mesmo ente federado caso haja vaga não preenchida por outros.
                    <br>
                    A CGSN/SE encaminhará, até o dia 04/11/2021, para o e-mail do servidor com inscrição validada, o link para preenchimento de formulário de confirmação e participação no evento, cujo prazo final de retorno dar-se-á em 08/11/2022.
                    <br>
                    O preenchimento do formulário de confirmação e participação no evento é obrigatório. O seu não preenchimento implicará na inadmissibilidade de acesso à sala virtual do treinamento.
                  </p>
                </div>
              </div>

              <div class="col-lg-6 mt-4 mt-lg-0">
                <div class="about-slider">
                  <div class="item">
                    <img class="w-100" 
                          src="../../assets/images/ibcgp/publications/maxtreinamentosefisc4.jpeg" 
                          alt="Imagem de valores do instituto"
                          style="border-radius: 15px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section class="section cta-hire bg-gary">
        <contact/>
      </section>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import Contact from '../contact/ShortcutContact.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Artigos e Publicações";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'contact'                 : Contact,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
    beforeMount() {
      this.navPublications = true;
    }
  }
</script>